<script setup lang="ts">
const _props = defineProps<{ data: unknown, theme: string | null | undefined }>()
const iconRotate = ref<Record<number, boolean>>({})
</script>

<template>
  <div class="px-bleed w-full relative">
    <ElementsAccordion
      v-for="(item, index) in data.items"
      :key="index"
      :show-icon="true"
      class="lg:w-cols-6 border-(--theme-fg)/15 relative block w-full border-b !px-0 lg:ml-auto"
      @open="iconRotate[index] = true"
      @close="iconRotate[index] = false"
    >
      <template #summary>
        <h3 class="font-display py-6 text-base font-bold">{{ item.title }}</h3>
        <IconsChevronDown
          v-if="item.content"
          class="size-4 transition-all"
          :class="{ 'rotate-180': iconRotate[index] }"
        />
      </template>
      <template #content>
        <div class="py-6">
          <ElementsPortableTextWrapper :content="item.content" />
        </div>
      </template>
    </ElementsAccordion>
  </div>
</template>
